"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCharity = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M39.44 40.55a1.6 1.6 0 0 0 2.26 0l14.1-14.1a10.68 10.68 0 0 0 0-15.09 10.68 10.68 0 0 0-15.09 0l-.13.13-.13-.13a10.67 10.67 0 0 0-15.11 15.09zm14.1-16.36l-13 13-13-13a7.47 7.47 0 0 1 10.63-10.57l1.26 1.26a1.6 1.6 0 0 0 2.26 0L43 13.63a7.46 7.46 0 0 1 10.5-.07l.07.07a7.48 7.48 0 0 1-.04 10.56z"
  }), _react["default"].createElement("path", {
    d: "M62.7 43.17a4.39 4.39 0 0 0-5.48-2.36l-15 5.33a4.36 4.36 0 0 0-2-1.64L25 38.43a8.28 8.28 0 0 0-6.7.21l-.81.39v-.64a1.6 1.6 0 0 0-1.6-1.6H7.53a1.6 1.6 0 0 0-1.6 1.6v20.25a1.6 1.6 0 0 0 1.6 1.6h8.33a1.6 1.6 0 0 0 1.6-1.6v-2.26a7.89 7.89 0 0 1 4.57.17l9.25 3.15a11.09 11.09 0 0 0 8.43-.51l20.86-10a4.56 4.56 0 0 0 2.13-6.02zm-3.51 3.09l-20.86 10a7.9 7.9 0 0 1-6 .36l-9.25-3.15a11.14 11.14 0 0 0-3.6-.6 11 11 0 0 0-2 .2V42.58l2.2-1.06a5.07 5.07 0 0 1 4.11-.12L39 47.47a1.25 1.25 0 0 1 .66 1.61 1.18 1.18 0 0 1-.63.68 1.09 1.09 0 0 1-.87 0l-11-4.39a1.6 1.6 0 1 0-1.18 3l11 4.39a4.25 4.25 0 0 0 3.33 0 4.36 4.36 0 0 0 2.35-2.47 4.46 4.46 0 0 0 .25-.93l15.41-5.46a1.21 1.21 0 0 1 1.5.67 1.34 1.34 0 0 1-.64 1.69zM9.13 40h5.13v17H9.13z"
  })),
  height: undefined,
  width: undefined
});
IconCharity.displayName = 'IconCharity';
var _default = IconCharity;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/charity.js
// module id = 553
// module chunks = 0